import { Image } from '@mantine/core';
import {
  Box, Alert, IconButton
} from '@huspy/briks-web';
import { imagesPath } from '@shared/css.const';
import { useState } from 'react';
import { Cancel } from '@huspy/briks-icons';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import { AMPLITUDE_FEATURE_FLAGS } from '@modules/core/api/types';
import creditExpirationBannerStyles from './styles';

const {
  alert, wrapper, closeButton, content,
} = creditExpirationBannerStyles;

export const CreditExpiredNotificationBanner = () => {
  const [visible, setVisible] = useState(true);
  const { featureFlags, isFeatureFlagsLoading } = useFeatureFlags();

  const isCreditExpirationBannerVisibleFF = !isFeatureFlagsLoading
   && featureFlags?.[AMPLITUDE_FEATURE_FLAGS.CLIENT_HUB_CREDITS_MODULE]
   && featureFlags?.[AMPLITUDE_FEATURE_FLAGS.CLIENT_HUB_CREDIT_EXPIRATION_BANNER];

  const showBanner = isCreditExpirationBannerVisibleFF && visible;

  const handleOnClose = () => {
    setVisible(false);
  };
  return (
    <>
      {
        showBanner && (
          <Box className={ wrapper }>
            <Alert.Root className={ alert } data-testid='credit-expiration-notification-banner'>
              <Image
                src={ `${imagesPath}/credits.png` }
                h={ 26 }
              />
              <Alert.Content className={ content }>
                <Alert.Title data-testid='credit-expiration-banner-title'>
                  Your gifted credits will expire on January 15, 2025!
                </Alert.Title>
                <Alert.Description data-testid='credit-expiration-banner-description'>
                  Use them now to make the most of your portal experience. Contact Huspy for more info
                </Alert.Description>
              </Alert.Content>
              <Box marginLeft='auto'>
                <IconButton
                  variant='tertiary'
                  size='sm'
                  onClick={ handleOnClose }
                  data-testid='credit-expiration-banner-close-btn'
                  className={ closeButton }
                >
                  <Cancel />
                </IconButton>
              </Box>
            </Alert.Root>
          </Box>
        )
      }
    </>
  );
};
